import { GoSidebarCollapse } from "react-icons/go";

import { Icon, IconButton, IconButtonProps, useBreakpointValue } from "@chakra-ui/react";

import { useLeftDrawer } from "@/providers/useDrawers";

function LeftDrawerHeaderControl({ ...props }: Partial<IconButtonProps>) {
  const { onOpen: onOpenLeft } = useLeftDrawer();
  if (!useBreakpointValue({ base: true, xl: false })) return null;

  return (
    <IconButton
      aria-label="menu"
      icon={<Icon as={GoSidebarCollapse} />}
      size="lg"
      variant="highlight"
      onClick={onOpenLeft}
      {...props}
    />
  );
}

export default LeftDrawerHeaderControl;
